<template>
    <div class="InfluencerSearch">
        <div>
            <div class="">
                <form>
                    <div class="flex flex-wrap w-3/4 mb-4" style="margin: 0 auto;">
                        <!--
            <div class="w-full md:w-1/4 px-2 mb-4 md:mb-0">
              <label class="block text-gray-700 font-bold mb-2" for="age-group">
                Aldersgruppe
              </label>
              <select @change="onChange('ageGroup', $event)" v-model="ageGroup" class="form-select block w-full rounded-md bg-gray-100 py-2 px-3" id="age-group">
                <option value="">Alle</option>
                <option value="0-18">Under 18</option>
                <option value="18-24">18-24</option>
                <option value="25-34">25-34</option>
                <option value="35-44">35-44</option>
                <option value="45-54">45-54</option>
                <option value="55-64">55-64</option>
                <option value="65-plus">65+</option>
              </select>
            </div>
            -->
                        <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                            <label class="block text-white font-bold mb-2" for="media">
                                Platform
                            </label>
                            <v-select
                                @input="onChange"
                                v-model="media.value"
                                :searchable="false"
                                :options="media.options"
                                label="name"
                                multiple
                            ></v-select>
                        </div>
                        <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                            <label class="block text-white font-bold mb-2" for="country">
                                Land
                            </label>
                            <v-select
                                @input="onChange"
                                v-model="country.value"
                                :searchable="false"
                                :options="country.options"
                                label="name"
                                multiple
                            ></v-select>
                        </div>
                        <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                            <label class="block text-white font-bold mb-2" for="gender">
                                Køn
                            </label>
                            <v-select
                                @input="onChange"
                                v-model="gender.value"
                                :searchable="false"
                                :options="gender.options"
                                label="name"
                                multiple
                            ></v-select>
                        </div>
                        <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                            <label class="block text-white font-bold mb-2" for="interests">
                                Verdensmål
                            </label>
                            <v-select
                                @input="onChange"
                                v-model="interests.value"
                                :searchable="false"
                                :options="interests.options"
                                label="name"
                                multiple
                            ></v-select>
                        </div>
                        <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                            <label class="block text-white font-bold mb-2" for="favorites">
                                Favorit
                            </label>
                            <v-select
                                @input="onChange"
                                v-model="favorites.value"
                                :searchable="false"
                                :options="favorites.options"
                                label="name"
                                multiple
                            ></v-select>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div v-if="totalInfluencers !== null || loading" class="text-center my-6">
            <p class="text-white text-[16px] font-semibold">
                <span v-if="!loading">
                    {{ totalInfluencers }} influencere matcher din søgning
                </span>
            </p>
        </div>

        <div
            v-if="!loading"
            class="flex flex-wrap -mx-2 my-4"
            style="margin: 0 auto; margin-top: 80px;"
        >
            <div
                v-for="result in results"
                class="search-influencer-container inline-block w-full md:w-1/2 mx-auto py-0 px-2 md:px-8"
                style="vertical-align: top;margin-bottom: 70px;"
            >
                <div
                    :href="'/influencers/' + result.id"
                    class="catch-13 inline-block well p-0 w-full h-full"
                >
                    <div class="flex flex-wrap">
                        <div class="w-full mb-4 md:mb-0 md:w-2/5">
                            <img
                                :src="result.profile_photo_url"
                                class="spark-profile-photo-xxl mx-auto mb-4"
                                :alt="result.name"
                                style="margin-top: -40px; border: 0;"
                            />
                        </div>
                        <div class="w-full md:w-3/5 pl-5">
                            <p style="font-size: 18px;font-weight: 600;margin-top: 20px;">
                                {{ result.name }}
                            </p>
                            <div class="mt-5">
                                <div class="flex">
                                    <div class="w-1/2 flex cursor-pointer">
                                        <span
                                            v-if="!result.favorite"
                                            id="fav-heart-off"
                                            @click="toggleFavorite(result.id)"
                                            class="fa fa-heart-o mr-2"
                                            style="width: 15px; text-align: center; color: #1825d8; position: absolute; margin-top: 3px;"
                                        />
                                        <span
                                            v-else
                                            id="fav-heart-on"
                                            @click="toggleFavorite(result.id)"
                                            class="fa fa-heart mr-2"
                                            style="width: 15px; text-align: center; color: red; position: absolute; margin-top: 3px;"
                                        />
                                        <p
                                            v-if="!result.favorite"
                                            id="fav-heart-text-off"
                                            @click="toggleFavorite(result.id)"
                                            class="uppercase"
                                            style="font-size: 14px; margin-left: 20px;"
                                        >
                                            Tilføj favorit
                                        </p>
                                        <p
                                            v-else
                                            id="fav-heart-text-on"
                                            @click="toggleFavorite(result.id)"
                                            class="uppercase"
                                            style="font-size: 14px; margin-left: 20px;"
                                        >
                                            Fjern favorit
                                        </p>
                                    </div>
                                    <div class="w-1/2 pl-2 uppercase" style="font-size: 14px;">
                                        {{ result.gender ? result.gender.name : 'Ikke angivet' }}
                                    </div>
                                </div>
                                <div class="flex">
                                    <div class="w-1/2 flex" v-if="result.country">
                                        <span
                                            class="fa fa-map-marker mr-2"
                                            style="width: 15px; text-align: center; color: #1825d8; position: absolute; margin-top: 3px;"
                                        />
                                        <!--<span class="fa fa-heart mr-2" style="color: red" />-->
                                        <p
                                            class="uppercase"
                                            style="font-size: 14px; margin-left: 20px;"
                                        >
                                            {{
                                                country.options.find(
                                                    option => option.value === result.country
                                                ).name || 'Ikke angivet'
                                            }}
                                        </p>
                                    </div>
                                    <div
                                        class="w-1/2 pl-2 uppercase magic-color-stars"
                                        style="font-size: 14px;"
                                    >
                                        <RatingStars
                                            :value="result.reviews_score"
                                            class=""
                                            :disabled="true"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="px-4 mb-5 mt-2">
                        <p>{{ result.bio && result.bio.length > 200 ? result.bio.substring(0, 200) + '...' : result.bio }}</p>
                    </div>
                    <div
                        v-if="result.channels"
                        style="margin-bottom: 20px;padding: 10px 20px;flex-wrap: wrap;"
                        class="flex w-full"
                    >
                        <div
                            v-if="channel.platform"
                            v-for="channel in result.channels"
                            class="flex w-1/2"
                        >
                            <div>
                                <span
                                    style="color: #1825d8;font-size: 30px;margin-right: 10px;"
                                    :class="channel.platform ? channel.platform.icon : ''"
                                ></span>
                            </div>
                            <div style="font-size: 14px;line-height: 1.2;">
                                <p class="font-bold">{{ channel.reach }}</p>
                                <p>{{ channel.platform ? channel.platform.reach_name : '' }}</p>
                            </div>
                        </div>
                    </div>

                    <div v-if="result.trophies.length > 0" class="px-5 pb-8 pt-3">
                        <div class="flex gap-2 md:gap-2.5 flex-wrap items-center">
                            <div
                                v-for="(trophy, index) in result.trophies"
                                class="item-trophy"
                                :class="{
                                    'hide-from-md': index > 4 && index <= 7,
                                    'hide-from-lg': index > 7
                                }"
                            >
                                <img
                                    :src="trophy.icon"
                                    :alt="trophy.name"
                                    class="h-11"
                                />
                            </div>
                            <div v-if="result.trophies.length > 8" class="font-semibold text-[22px] item-trophy-more-lg">
                                +{{result.trophies.length - 8}}
                            </div>
                            <div v-if="result.trophies.length > 5" class="font-semibold text-[22px] item-trophy-more-md">
                                +{{result.trophies.length - 5}}
                            </div>
                        </div>
                    </div>
                    <div style="padding: 0px 20px;">
                        <div class="flex">
                            <div>
                                <img
                                    src="/img/interests-icon.png"
                                    alt="interests"
                                    style="width: 50px;"
                                />
                            </div>
                            <p style="line-height: 45px;margin-left: 10px;font-weight: 600;">
                                Verdensmål
                            </p>
                        </div>
                        <div class="interests-wrapper">
                            <div
                                v-for="(interest, index) in result.interests.slice(0, 4)"
                                :key="index"
                                class="interest-box"
                                style="
                                    display: block;
                                    width: calc(25% - 10px);
                                    float: left;
                                    margin: 10px;
                                    margin-left: 0;
                            "
                            >
                                <img
                                    :src="'/img/interests/' + interest.id + '.png'"
                                    :alt="interest.name"
                                />
                            </div>
                            <div style="clear: both;" />
                        </div>

                        <div class="flex flex-wrap gap-3 justify-between mb-5 px-5 mt-10">
                            <a
                                class="w-full md:w-auto text-center"
                                :href="'/influencers/' + result.id"
                                @click="saveCurrentPage"
                                style="background: rgb(24, 37, 216);font-size: 13px;font-weight: 600;padding: 7px 12px;border-radius: 0;text-transform: uppercase;color: white;"
                                >Se profil</a
                            >
                            <button
                                @click="toggleMenu(result.id)"
                                class="btn btn-primary w-full md:w-auto"
                                style="background: red;font-size: 13px;font-weight: 600;padding: 7px 12px;border-radius: 0;text-transform: uppercase;color: white;"
                            >
                                Inviter til kampagne
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <modal
                size="md"
                class="modal-invited flex items-center justify-center"
                v-if="isMenuVisible"
                @close="isMenuVisible = false"
            >
                <div class="w-full md:w-1/2 px-2 mb-4 md:mb-0">
                    <div class="w-full">
                        <label class="block text-black font-bold mb-2" for="campaigns">
                            Mine kampagner
                        </label>
                        <select
                            class="form-select block w-full rounded-md bg-gray-100 py-2 px-3"
                            id="campaigns"
                        >
                            <option v-for="(item, index) in campaigns" :value="item.id">{{
                                item.name
                            }}</option>
                        </select>
                        <button
                            @click="submitCampaign"
                            class="btn btn-primary mt-4 w-full"
                            style="background: red;font-size: 13px;font-weight: 600;padding: 7px 12px;border-radius: 0;text-transform: uppercase;color: white;"
                        >
                            Invitere
                        </button>
                    </div>
                </div>
            </modal>

            <div class="pagination block mt-2 w-full text-center">
                <button @click="prevPage" :disabled="page == 1" class="btn btn-default">
                    Forrige
                </button>
                <button @click="nextPage" :disabled="page == lastPage" class="btn btn-default">
                    Næste
                </button>
            </div>
        </div>

        <PageLoader :loading="loading" />
    </div>
</template>

<style type="text/less" lang="less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';
@import '~dashboard-less/spark/components/Tabs';
@import '~vue-select/dist/vue-select.css';

.InfluencerProfile {
    .Tabs(@brand-primary);
}

.InfluencerProfile .Tabs > li:not(.active) > a {
    @apply text-gray-700;
}

.InfluencerProfile {
    .CoverImage {
        min-height: 150px;
    }

    .InfluencerProfile__cover {
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2));

        .RatingStars .star {
            font-size: 30px;
        }
    }
}
.modal-invited {
    border-radius: 0;
}
.modal-invited::before {
    content: '';
    display: block;
    width: 50px;
    height: 25%;
    background: #ffffff;
    position: absolute;
    top: 0;
    left: -50px;
}
.modal-invited::after {
    content: '';
    display: block;
    width: 50px;
    height: 77%;
    background: #ffffff;
    position: absolute;
    top: 21%;
    left: -16px;
    transform: rotate(-11deg);
}
.item-trophy.hide-from-lg{
    display: none;
}
.item-trophy-more-md{
    display: none;
}
@media (max-width: 768px) {
    .item-trophy-more-lg{
        display: none;
    }
    .item-trophy-more-md{
        display: block;
    }
    .item-trophy.hide-from-md{
        display: none;
    }
}
// input.vs__search {
//     display: none;
// }

// button.vs__deselect {
//     scale: 0.7;
//     margin-left: -2px;
// }

// svg.vs__open-indicator {
//     position: absolute;
//     top: 12px;
//     right: 10px;
//     z-index: 1;
// }

// .vs__dropdown-toggle {
//     position: relative;
// }

.vs__selected-options {
    // background: #f8fafc;
    // min-height: 35px;
    // padding: 3px 7px;
    // color: black;
    // border-radius: 3px;
    font-weight: 400;
    font-size: 10px;
}

.vs__dropdown-menu {
    // position: absolute;
    // width: 100%;
    // background: #f8fafc;
    // border: 1px solid rgb(0 0 0 / 20%);
    // z-index: 1;
    // padding: 3px 7px;
    min-width: 210px;
    width: auto;
}

@media (max-width: 768px) {
    .vs__dropdown-menu {
        max-width: calc(100vw - 120px);
    }
    .vs__dropdown-option {
        white-space: normal;
    }
}
</style>
<script type="text/babel">
import CoverImage from 'dashboard-js/components/utilities/CoverImage'
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import InfluencerProfileChannelsTab from './InfluencerProfileChannelsTab'
import InfluencerProfileReviewsTab from 'dashboard-js/components/influencers/InfluencerProfileReviewsTab'
import PageLoader from 'dashboard-js/components/utilities/PageLoader'
import RatingStars from 'dashboard-js/components/reviews/RatingStars'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'
import Tab from 'dashboard-js/components/tabs/Tab'
import TabContent from 'dashboard-js/components/tabs/TabContent'
import TabPanel from 'dashboard-js/components/tabs/TabPanel'
import Tabs from 'dashboard-js/components/tabs/Tabs'
import TextBlock from 'dashboard-js/components/utilities/TextBlock'
import vSelect from 'vue-select'
import TextareaAutosized from 'dashboard-js/components/utilities/TextareaAutosized'

export default {
    components: {
        TextareaAutosized,
        TabPanel,
        Tab,
        TabContent,
        Tabs,
        RatingStars,
        CoverImage,
        TextBlock,
        PageLoader,
        InfluencerProfileReviewsTab,
        InfluencerProfileChannelsTab,
        vSelect,
    },

    mixins: [HasLoadingState, RestoreOnPageBack],

    props: ['apiUrl', 'filters'],

    data() {
        return {
            results: [],
            page: 1,
            lastPage: null,
            totalInfluencers: null,
            campaigns: [],
            selectedInfluencerId: null,

            ageGroup: {
                value: null,
                options: [
                    { name: '13-17', value: '13-17' },
                    { name: '18-24', value: '18-24' },
                    { name: '25-34', value: '25-34' },
                    { name: '35-44', value: '35-44' },
                    { name: '45-54', value: '45-54' },
                    { name: '55-64', value: '55-64' },
                    { name: '65+', value: '65+' },
                ],
            },

            country: {
                value: null,
                options: [
                    { name: 'Danmark', value: 'DK' },
                    { name: 'Sverige', value: 'SE' },
                    { name: 'Norge', value: 'NO' },
                ],
            },

            favorites: {
                value: null,
                options: [
                    { name: 'Kun favoritter', value: 'favorites' },
                    { name: 'Ikke favoritter', value: 'without_favorites' },
                ],
            },

            gender: {
                value: null,
                options: window.Spark.genders,
            },

            interests: {
                value: null,
                options: window.Spark.interests,
            },

            media: {
                value: null,
                options: window.Spark.platforms,
            },
            userId: {
                value: window.Spark.userId,
            },
            isMenuVisible: false,
        }
    },
    mounted() {
        this.fetchCampaigns()
    },

    computed: {
        endpoint() {
            return (
                `${this.apiUrl}-api` +
                `?page=${this.page}` +
                `&ageGroup=${this.ageGroupFilter}` +
                `&country=${this.countryFilter}` +
                `&gender=${this.genderFilter}` +
                `&interest=${this.interestFilter}` +
                `&media=${this.mediaFilter}` +
                `&favorites=${this.favoritesFilter}`
            )
        },

        // activeCampaigns() {
        //   return `campaigns-api` +
        //       `?userId=${this.userId.value}`
        // },
        ageGroupFilter() {
            return ''
        },

        countryFilter() {
            if (this.country.value) {
                return this.country.value.map(obj => obj.value).join(',')
            }

            return ''
        },

        genderFilter() {
            if (this.gender.value) {
                return this.gender.value.map(obj => obj.id).join(',')
            }

            return ''
        },

        interestFilter() {
            if (this.interests.value) {
                return this.interests.value.map(obj => obj.id).join(',')
            }

            return ''
        },

        mediaFilter() {
            if (this.media.value) {
                return this.media.value.map(obj => obj.id).join(',')
            }

            return ''
        },

        favoritesFilter() {
            if (this.favorites.value) {
                return this.favorites.value.map(obj => obj.value).join(',')
            }

            return ''
        },
    },

    created() {
        const savedPage = localStorage.getItem('influencerSearchPage');
        if (savedPage) {
            this.page = parseInt(savedPage, 10);
            // Delete the saved page from localStorage
            localStorage.removeItem('influencerSearchPage');
        }
        this.search()
    },

    methods: {
        saveCurrentPage() {
            localStorage.setItem('influencerSearchPage', this.page);
        },
        restoreSavedPage() {
            // Restore the saved page number from sessionStorage
            const savedPage = sessionStorage.getItem('influencerSearchPage')
            if (savedPage) {
                this.page = parseInt(savedPage)
            }
        },
        toggleMenu(influencerId) {
            this.isMenuVisible = !this.isMenuVisible
            this.selectedInfluencerId = influencerId
        },

        toggleFavorite($userId) {
            let endpoint = this.apiUrl.replace('/influencers', '/api/influencers')
            endpoint = `${endpoint}/${$userId}/favorite`

            axios.get(endpoint).then(response => {
                const influencerIndex = this.results.findIndex(
                    influencer => influencer.id === $userId
                )
                if (influencerIndex !== -1) {
                    this.results[influencerIndex].favorite = response.data.favorite
                }
            })
        },

        campaignsEndpoint() {
            return `campaigns-api?userId=${this.userId.value}`
        },

        fetchCampaigns() {
            axios.get(this.campaignsEndpoint()).then(response => {
                this.campaigns = response.data.campaigns
            })
        },

        submitCampaign() {
            const selectedCampaignId = document.getElementById('campaigns').value
            if (selectedCampaignId) {
                axios
                    .post('/campaigns-submit', {
                        campaignId: selectedCampaignId,
                        influencerId: this.selectedInfluencerId,
                    })
                    .then(response => {
                        this.isMenuVisible = false
                        this.selectedInfluencerId = null
                        console.log('Show success message')
                        // Handle success (e.g., show success message)
                    })
                    .catch(error => {
                        console.error('Error submitting campaign:', error)
                        console.log('Show error message')
                        // Handle error (e.g., show error message)
                    })
            } else {
                console.log('Show error message')
            }
        },

        nextPage() {
            this.page++
            this.search()
        },
        prevPage() {
            this.page--
            this.search()
        },
        onChange() {
            this.page = 1
            this.results = []
            this.search()
        },
        search() {
            this.loadingUntil(complete => {
                axios.get(this.endpoint).then(response => {
                    this.results = response.data.data
                    this.lastPage = response.data.meta.last_page
                    this.totalInfluencers = response.data.meta.total
                    complete()
                })
            })
        },
    },
}
</script>
